const POLL_INTERVAL_MS = 10 * 60 * 1000;

const noop = () => undefined;

let started = false;
let notified = false;

const fetchDeployed = async (): Promise<{ sha?: string; builtAt?: string } | undefined> => {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) return undefined;
    return (await res.json()) as { sha?: string; builtAt?: string };
  } catch {
    return undefined;
  }
};

/**
 * Polls /version.json and invokes `onNewVersion` once per session when the
 * deployed build differs from the one this bundle was built with. builtAt is
 * checked alongside the SHA so builds without a git stamp still detect deploys.
 */
export const startVersionCheck = (onNewVersion: () => void): (() => void) => {
  if (!import.meta.env.PROD || started) return noop;
  started = true;

  const check = async () => {
    if (notified) return;
    const deployed = await fetchDeployed();
    if (!deployed) return;
    const shaChanged = !!deployed.sha && deployed.sha !== __BUILD_SHA__;
    const buildChanged = !!deployed.builtAt && deployed.builtAt !== __BUILD_TIME__;
    if (!shaChanged && !buildChanged) return;
    notified = true;
    onNewVersion();
  };

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') void check();
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
  const timer = window.setInterval(() => void check(), POLL_INTERVAL_MS);
  void check();

  return () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.clearInterval(timer);
    started = false;
  };
};
